export const categories = [
  { id: 1, name: "全部", slug: "all", count: 1256 },
  { id: 2, name: "恋爱", slug: "romance", count: 328 },
  { id: 3, name: "奇幻", slug: "fantasy", count: 256 },
  { id: 4, name: "动作", slug: "action", count: 198 },
  { id: 5, name: "悬疑", slug: "thriller", count: 167 },
  { id: 6, name: "搞笑", slug: "comedy", count: 142 },
  { id: 7, name: "耽美", slug: "bl", count: 89 },
  { id: 8, name: "剧情", slug: "drama", count: 76 },
];

export const categoryData = {
  categories,
  getCategoryBySlug: (slug: string) => categories.find((c) => c.slug === slug),
};